import { Box } from "@mui/material";
import styled from "@emotion/styled";

export const ContainerStyle = styled(Box)({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "100vh",
    padding: "16px",
});
